import {isAxiosError} from "axios";

type ApiErrorBody = {
  error_code?: string;
  message?: string;
};

const RESIDENT_CONTEXT_ERROR_MESSAGES: Record<string, string> = {
  resident_context_property_required: "Select a property before continuing.",
  resident_context_household_required: "Select a unit before continuing.",
  resident_context_mismatch: "The selected property and unit do not match your account.",
  resident_context_membership_inactive: "This unit is no longer active on your account.",
  resident_context_household_forbidden: "You do not have access to this household.",
  occupancy_owner_read_only: "You cannot change tenant data while this unit is rented out.",
  tenant_creation_task_retired:
    "Tenant setup tasks are no longer available. Invite tenants from your home screen.",
  tenant_deactivation_task_retired:
    "Tenant removal tasks are no longer available. End tenancy from your home screen.",
};

export function getResidentContextErrorCode(error: unknown): string | null {
  if (!isAxiosError<ApiErrorBody>(error)) return null;
  const code = error.response?.data?.error_code;
  return typeof code === "string" && code.length > 0 ? code : null;
}

export function getResidentContextErrorMessage(
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  const code = getResidentContextErrorCode(error);
  if (code && RESIDENT_CONTEXT_ERROR_MESSAGES[code]) {
    return RESIDENT_CONTEXT_ERROR_MESSAGES[code];
  }

  if (isAxiosError<ApiErrorBody>(error)) {
    const message = error.response?.data?.message?.trim();
    if (message) return message;
  }

  return fallback;
}
